/* unplugin-vue-components disabled */import { render } from "./m-footer.vue?vue&type=template&id=37af06b7"
const script = {}

import "./m-footer.vue?vue&type=style&index=0&id=37af06b7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__